import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['slide', 'nav']

  initialize() {
    this.showCurrentSlide()
    this.initAutoPlay()
  }

  initAutoPlay() {
    const self = this
    self.timer = setInterval(() => {
      self.index++
      if (self.index === self.slideTargets.length) {
        self.index = 0
      }
    }, 6000)
  }

  goToSlide(event) {
    this.index = event.currentTarget.dataset.index
    clearInterval(this.timer)
    this.initAutoPlay()
  }

  showCurrentSlide() {
    this.slideTargets.forEach((element, index) => {
      if (index === this.index) {
        element.classList.replace('invisible', 'visible')
        element.classList.replace('opacity-0', 'opacity-100')
      } else {
        element.classList.replace('visible', 'invisible')
        element.classList.replace('opacity-100', 'opacity-0')
      }
    })
    this.navTargets.forEach((element, index) => {
      if (index === this.index) {
        element.classList.add('bg-white')
      } else {
        element.classList.remove('bg-white')
      }
    })
  }

  nextSlide() {
    if (this.index < this.slideTargets.length - 1) {
      this.index++
    }
  }

  previousSlide() {
    if (this.index > 0) {
      this.index--
    }
  }

  get index() {
    return this.data.has('index') ? parseInt(this.data.get('index')) : 0
  }

  set index(value) {
    this.data.set('index', value)
    this.showCurrentSlide()
  }
}
